<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>

          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <a href="/admin">CRCB Control Panel</a> > <a href="/admin/user">權限管理</a> > <span>管理員{{mode}}</span>
            <h1 class="h3 mb-2 mt-2 text-gray-800">管理員{{mode}}</h1>

            <!-- DataTales Example -->
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <button type="button" class="btn btn-primary" v-on:click="Post" v-if="!is_edit ">新增</button>
                <button type="button" class="btn btn-primary" v-on:click="Update" v-if="is_edit ">儲存</button>
                <button type="button" class="btn btn-danger" v-on:click="Delete" data-bs-toggle="tooltip" data-bs-placement="top" v-if="is_edit">刪除</button>
              </div>
              <div class="card-body">
                <form>
                  <div class="form-group">
                      <label for="email">帳號* <label v-if="user.is_superuser" class="text-danger">超級帳號</label></label>
                      <input type="email" class="form-control form-control-user" id="email"  v-model="user.email" >
                  </div>
                  <div class="form-group">
                      <label>姓名*</label>
                      <input type="text" class="form-control form-control-user" id="InputDisplayName"  v-model="user.name" autocomplete="username" >
                  </div>
                  <div class="form-group">
                      <label>密碼*</label>
                      <input type="password" class="form-control form-control-user" id="InputPassword"  v-model="password" autocomplete="new-password">
                  </div>
                  <div class="form-group">
                      <label>密碼確認*</label>
                      <input type="password" class="form-control form-control-user" id="InputPasswordCheck"  v-model="password_check" autocomplete="new-password">
                  </div>
                  <fieldset class="form-group">
                    <div class="row">
                      <legend class="col-form-label col-sm-2 pt-0">停權/復權</legend>
                      <div class="col-sm-10">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="is_disabeld" id="enabled" v-model="user.is_disabled" value="false" checked>
                          <label class="form-check-label" for="enabled">
                            正常
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="is_disabeld" id="disabled" v-model="user.is_disabled" value="true">
                          <label class="form-check-label" for="disabled">
                            停權
                          </label>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="banner">Banner管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="banner" v-model="user.permission.banner">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="faculty">中心成員管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="faculty" v-model="user.permission.faculty">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="newss">內容管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="newss" v-model="user.permission.news">
                      </div>
                    </div>
                  </div>
                   <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="category">類別管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="category" v-model="user.permission.category">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="activity">活動剪影管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="activity" v-model="user.permission.activity">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="contact">聯絡表單管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="contact" v-model="user.permission.contact">
                      </div>
                    </div>
                  </div>
                 <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="banner_en">英文版Banner管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="banner_en" v-model="user.permission.banner_en">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="faculty_en">英文版中心成員管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="faculty_en" v-model="user.permission.faculty_en">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="news_en">英文版內容管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="news_en" v-model="user.permission.news_en">
                      </div>
                    </div>
                  </div>
                   <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="category_en">英文版類別管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="category_en" v-model="user.permission.category_en">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="activity_en">英文版活動剪影管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="activity_en" v-model="user.permission.activity_en">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-2">
                        <label class="form-check-label" for="contact_en">英文版聯絡表單管理</label>
                    </div>
                    <div class="col-sm-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="contact_en" v-model="user.permission.contact_en">
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

       <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
import Sidebar from './shared/Sidebar'
import Topbar from './shared/Topbar'
import Footer from './shared/Footer'
export default {
  name: 'UserInfo',
  data () {
    return {
      id:this.$route.params.id,
      mode:'',
      is_edit:false,
      valid:{
        email:false
      },
      user:{
        email:'',
        name:'',
        password:'',
        is_disabled:false,
        is_superuser:false,
        permission:{
          activity:false,
          activity_en:false,
          banner:false,
          banner_en:false,
          category:false,
          category_en:false,
          contact:false,
          contact_en:false,
          faculty:false,
          faculty_en:false,
          news:false,
          news_en:false
        }
      },
      password:'',
      password_check:''
    }
  },
  components: {
    Sidebar,Topbar,Footer
  },
  mounted () {
    this.Switch();
    this.Get();
  },
  methods: {
    Switch() {
      if ( this.$route.name == 'UserAdd'  ) {
          this.mode = '新增';
      } else {
          this.mode = '編輯';
          this.is_edit = true;
      }
    },
    Get(){
      if ( this.$route.name != 'UserAdd'  ) {
        db.collection("admin").doc(this.id).get().then((doc) => {
            if (doc.exists) {
              this.user = doc.data();
            } else {
              this.$router.push({path: '/user'});
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    Post() {
      if ( this.user.email == '' ) {
        alert('帳號不可為空!');
      } else if ( this.user.name == '' ) {
        alert('名字不可為空!')
      } else if ( this.password == '' ) {
        alert('密碼不可為空')
      } else if ( this.password != this.password_check ) {
        alert('密碼與確認密碼不相符') 
      } else {

        this.user.password = this.password;
        this.Beforesend();
        db.collection("admin").doc(this.id).set(this.user)
        .then((doc) => {
            alert("成功!");
            this.Aftersend();
            this.$router.push({path: '/admin/user'});
        }).catch((error) => {
            console.log("Error getting document:", error);
        });

      }   
    },
    Update() {

      var pass = true;
      if ( this.password != '' ) {
        // 密碼要修改就要檢查
        if ( this.password != this.password_check ) {
          alert('密碼與確認密碼不相符');
          pass = false;
        } else {
          this.user.password = this.password;

        }
      }

      if ( this.user.is_disabled == 'true' ) this.user.is_disabled= true;
      else this.user.is_disabled= false;
      
      if ( pass ) {
        console.log(this.user);
        var user_id = localStorage.getItem("user_id");
        var vm = this;
        this.Beforesend();
        db.collection("admin").doc(this.id).update(this.user)
          .then(() => {
              alert("成功!");
              this.Aftersend();
              //  修改是登入的user, 權限更換
              if ( vm.id == user_id ) {
                localStorage.setItem("user_data", JSON.stringify(vm.user.permission))
              }

              this.$router.push({path: '/admin/user'});
              


          }).catch((error) => {
              console.log("Error getting document:", error);
          });

      }
    },
    Delete() {
      if ( confirm("確定要刪除?") ) {
        this.Beforesend();
        db.collection("admin").doc(this.id).delete()
        .then(() => {
            alert("刪除成功!");
            this.Aftersend();
            this.$router.push({path: '/admin/user'});
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    }
  }
}
</script>

<style scoped>
label{
  cursor: pointer;
}
input[type=checkbox]{
  display:block;
}
</style>


// WEBPACK FOOTER //
// src/components/UserInfo.vue